module.exports = __webpack_public_path__ + "img/Room_100h.f14e519b.png";